import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import "./card.css";
import "./VerifiedBadge.css";
import DayOfWeekChip from "./dayChip";


export default function CardComponent(props) {

  return (
    <div className="card-wrapper">
      <Link
        to={`/runclubs/${props.data.city.toLowerCase().replace(/\s+/g, "-")}/${props.data.id}`}
        className="card-link"
      >
        <div className="img-holder">
        <img src={props.data.img} alt={`Image for ${props.data.title}`}/>
        </div>
        {props.data.topclub && <div className="top-club">🔥 Top Club</div>}
        <div className="card-content">
          <div className="card-title-wrapper">
            <div className="card-title">{props.data.title}</div>
          </div>
          <div className="card-subtitle">{props.data.subtitle}</div>
          <div className="card-description">{props.data.description}</div>
          <DayOfWeekChip days={props.data.daysOfWeek} />
        </div>
      </Link>
    </div>
  );
}
